import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

const GetRolePermissions = async roleId => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.RBAC_ROLE_PERMISSIONS.replace(':roleId', encodeURIComponent(roleId))
)

const GetRolePermissionTree = async roleId => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.RBAC_ROLE_PERMISSION_TREE.replace(':roleId', encodeURIComponent(roleId))
)

const GetPermissionMatrix = async () => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.RBAC_MATRIX
)

const RbacService = {
  GetRolePermissions,
  GetRolePermissionTree,
  GetPermissionMatrix
}

export default RbacService
